import { useGetOne } from 'react-admin';

import { transformDeclineReasonOptionsResponse } from './wellness-program-utils';

export const DECLINE_REASON_OPTIONS_SERVICE = 'cancellations';

export function useDeclineReasonOptions() {
  return useGetOne(
    DECLINE_REASON_OPTIONS_SERVICE,
    {
      id: 'wellness-decline-reasons',
    },
    {
      select: transformDeclineReasonOptionsResponse,
    }
  );
}
